import React, { useEffect, useState } from 'react';
import './login.css';
import { Navigate } from 'react-router-dom';
import { useAuthenticate } from '../../hooks';
import { DASHBOARD_PATH } from '../../router/RouteConstants';
import Header from '../../layout/Header/Header';
import AIEduButton from '../../components/Button/AIEduButton';
import googleIcon from '../../assets/images/google_colored_login.svg';
import microsoftIcon from '../../assets/images/microsoft_colored_login.svg';
import { useIntl } from 'react-intl';
import { API } from '../../services';
import { APP_VERSION } from '../../utils/Constants';

const Login = () => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const { auth } = useAuthenticate();

    const [termUrl, setTermUrl] = useState(null);
    const [policyUrl, setPolicyUrl] = useState(null);
    const [cookiePolicyUrl, setCookiePolicyUrl] = useState(null);

    const LOGIN_URL =
        process.env.REACT_APP_AI_ASSISTANCE_HOST + '/ums/auth/login';

    const handleGoogleSignInBtnClick = async () => {
        window.location.replace(LOGIN_URL);
    };

    const handleMicrosoftSignInBtnClick = async () => {
        window.location.replace(`${LOGIN_URL}?idp=microsoft`);
    };

    const SignInButtonStyle = ({ text, icon, handleClick, btnStyle }) => {
        return (
            <AIEduButton
                className={btnStyle}
                severity='secondary'
                label={
                    <div className='flex ml-5'>
                        <div className='account_logo'>
                            <img src={icon} />
                        </div>
                        <div className='flex align-items-center'>{text}</div>
                    </div>
                }
                onClick={handleClick}
                outlined
            />
        );
    };

    useEffect(() => {
        if (auth) {
            return;
        }

        API.getTermsAndPolicy('orgId').then(({ data }) => {
            const { terms } = data;
            setTermUrl(terms?.[0]?.termUrl);
            setPolicyUrl(terms?.[1]?.termUrl);
            setCookiePolicyUrl(terms?.[2]?.termUrl);
        });
    }, []);

    const handleNavigation = (url) => {
        if (!url) return;
        window.open(url, '_blank');
    };

    if (auth) {
        return <Navigate to={DASHBOARD_PATH} />;
    }

    return (
        <div className='page-layout'>
            <Header isLoginPage={true} />
            <div className='login'>
                <main className='main'>
                    <div className='main-header'>{f({ id: 'AI_EDU_SIGN_IN' })}</div>
                    <div className='login-text'>
                        {f({ id: 'AI_EDU_GET_STARTED_WITH_SAMSUNG_AI_ASSISTANT' })}
                    </div>
                    <div className='signin-options'>
                        <SignInButtonStyle
                            text={f({ id: 'AI_EDU_CONTINUE_WITH_GOOGLE' })}
                            icon={googleIcon}
                            btnStyle='btn btnPrimary'
                            handleClick={handleGoogleSignInBtnClick}
                        />
                        <SignInButtonStyle
                            text={f({ id: 'AI_EDU_CONTINUE_WITH_MICROSOFT' })}
                            icon={microsoftIcon}
                            btnStyle='btn btnPrimary'
                            handleClick={handleMicrosoftSignInBtnClick}
                        />
                    </div>
                </main>
                <footer className='footer'>
                    <div>{f({ id: 'AI_EDU_SERVER_VERSION' })} {APP_VERSION}</div>
                    <div
                        onClick={() => handleNavigation(termUrl)}
                        className='cursor-pointer hover:underline'
                    >
                        {f({ id: 'AI_EDU_TERMS_AND_CONDITION' })}
                    </div>
                    <div
                        onClick={() => handleNavigation(policyUrl)}
                        className='cursor-pointer hover:underline'
                    >
                        {f({ id: 'AI_EDU_PRIVACY_POLICY' })}
                    </div>
                    <div
                        onClick={() => handleNavigation(cookiePolicyUrl)}
                        className='cursor-pointer hover:underline'
                    >
                        {f({ id: 'AI_EDU_COOKIE_POLICY' })}
                    </div>
                    <div>
                        {f({ id: 'AI_EDU_COPYRIGHT_TEXT' })}
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default Login;
